import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const AllergenFoodStainlessIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon style={{ width: 50, height: 51 }} viewBox="0 0 50 51" {...props}>
      <rect
        opacity="0.1"
        y="0.311523"
        width="50"
        height="50"
        rx="25"
        fill={colors.primary}
      />
      <path
        d="M40.7394 31.6611C40.6196 31.4697 40.41 31.3525 40.1847 31.3525H10.2369C10.0116 31.3525 9.80199 31.4697 9.68346 31.6611C9.56499 31.8525 9.55327 32.0921 9.65483 32.2939C10.5689 34.1234 12.4061 35.2588 14.4504 35.2588H35.9712C38.0142 35.2588 39.8514 34.1234 40.7681 32.2952C40.8671 32.0921 40.858 31.8538 40.7394 31.6611Z"
        fill={colors.primary}
      />
      <path
        d="M26.999 18.4671C27.1058 18.2262 27.167 17.9606 27.167 17.6807C27.167 16.6038 26.2907 15.7275 25.2139 15.7275C24.137 15.7275 23.2607 16.6038 23.2607 17.6807C23.2607 17.9606 23.322 18.2263 23.4287 18.4671C17.529 19.2783 12.8701 24.0283 12.2725 30.0505H38.154C37.5563 24.0309 32.8962 19.2783 26.999 18.4671ZM24.6058 22.2366C20.9639 22.4775 17.8272 24.8551 16.6175 28.294C16.5237 28.5609 16.2711 28.7288 16.0029 28.7288C15.9313 28.7288 15.8584 28.7171 15.7868 28.6924C15.4482 28.5726 15.2699 28.2015 15.3884 27.8616C16.7712 23.9293 20.3558 21.2119 24.5199 20.9371C24.8649 20.915 25.1879 21.1845 25.2126 21.5439C25.236 21.9033 24.9652 22.2132 24.6058 22.2366Z"
        fill={colors.primary}
      />
    </SvgIcon>
  );
};

export default AllergenFoodStainlessIcon;
